(function () {
  'use strict';

  // ---------- mobile nav toggle ----------
  var toggle = document.getElementById('navToggle');
  var links = document.getElementById('navLinks');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      var open = links.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    links.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        links.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ---------- nav "Guides" dropdown (click-to-open on mobile, hover on desktop via CSS) ----------
  document.querySelectorAll('.nav-dropdown-trigger').forEach(function (trigger) {
    var menu = trigger.nextElementSibling;
    trigger.addEventListener('click', function () {
      if (!window.matchMedia('(max-width:1100px)').matches) return;
      var open = menu.classList.toggle('open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // ---------- nav search ----------
  var searchToggle = document.getElementById('navSearchToggle');
  var searchPanel = document.getElementById('navSearchPanel');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = searchPanel.classList.toggle('open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (!searchPanel.classList.contains('open')) return;
      if (searchPanel.contains(e.target) || e.target === searchToggle) return;
      searchPanel.classList.remove('open');
      searchToggle.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchPanel.classList.contains('open')) {
        searchPanel.classList.remove('open');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus();
      }
    });
  }

  // ---------- scroll reveal ----------
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // ---------- quantity steppers (product + cart) ----------
  document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var dec = stepper.querySelector('[data-qty-decrease]');
    var inc = stepper.querySelector('[data-qty-increase]');
    if (!input) return;
    function clamp(v) {
      v = parseInt(v, 10);
      if (isNaN(v) || v < 1) v = 1;
      return v;
    }
    if (dec) dec.addEventListener('click', function () {
      input.value = clamp(parseInt(input.value || 1, 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (inc) inc.addEventListener('click', function () {
      input.value = clamp(parseInt(input.value || 1, 10) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    input.addEventListener('change', function () { input.value = clamp(input.value); });
  });

  // ---------- product gallery: slides + thumbnails ----------
  // Each media item (image or video) is its own slide; thumbnails and the
  // variant picker below both switch slides by matching data-media-id,
  // rather than swapping a single <img src> (which can't hold a video).
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));

    function showSlideByMediaId(mediaId) {
      mediaId = String(mediaId);
      var found = false;
      slides.forEach(function (slide) {
        var match = slide.getAttribute('data-media-id') === mediaId;
        slide.classList.toggle('active', match);
        if (match) found = true;
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('active', t.getAttribute('data-media-id') === mediaId);
      });
      return found;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlideByMediaId(thumb.getAttribute('data-media-id'));
      });
    });

    gallery.showSlideByMediaId = showSlideByMediaId;
  });

  // ---------- product image lightbox ----------
  document.querySelectorAll('[data-lightbox]').forEach(function (lightbox) {
    var slides = Array.prototype.slice.call(lightbox.querySelectorAll('[data-lightbox-slide]'));
    var current = 0;

    function show(index) {
      if (!slides.length) return;
      current = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('active', i === current); });
    }
    function open(index) {
      show(index || 0);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-gallery-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(parseInt(btn.getAttribute('data-lightbox-index'), 10) || 0);
      });
    });

    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  });

  // ---------- product variant picker + add to cart ----------
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Shopify's native line-item-property file upload (used by the custom
  // artwork field) rejects files over 20MB. Anything larger than that never
  // reaches our validation — Shopify's own front end returns a raw
  // "413 Request Entity Too Large" server error page instead of a JSON
  // response, so we must catch it client-side *before* submitting.
  var MAX_UPLOAD_BYTES = 20 * 1024 * 1024;

  function formatMB(bytes) {
    return (bytes / (1024 * 1024)).toFixed(1) + 'MB';
  }

  function findOversizedFile(form) {
    var fileInputs = form.querySelectorAll('input[type="file"]');
    var oversized = null;
    fileInputs.forEach(function (input) {
      if (oversized) return;
      var file = input.files && input.files[0];
      if (file && file.size > MAX_UPLOAD_BYTES) {
        oversized = file;
      }
    });
    return oversized;
  }

  function showFormMessage(form, text) {
    var msg = form.querySelector('[data-form-message]');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'form-errors';
      msg.setAttribute('data-form-message', '');
      msg.setAttribute('role', 'alert');
      var addBtn = form.querySelector('[data-add-to-cart]');
      if (addBtn && addBtn.parentNode === form) {
        form.insertBefore(msg, addBtn);
      } else {
        form.appendChild(msg);
      }
    }
    msg.textContent = text;
    msg.hidden = false;
  }

  function clearFormMessage(form) {
    var msg = form.querySelector('[data-form-message]');
    if (msg) msg.hidden = true;
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variantIdInput = form.querySelector('[name="id"]');
    var priceNow = form.querySelector('[data-price-now]');
    var priceWas = form.querySelector('[data-price-was]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var inventoryEl = form.querySelector('[data-inventory]');
    var gallery = document.querySelector('[data-gallery]');

    // "Buy more, save more" quantity-tier table (see snippets/quantity-tier-table.liquid).
    // That snippet is rendered server-side for whichever variant was selected
    // on page load, so without this it goes stale the moment a shopper picks
    // a different Size — it keeps showing the tier pricing for the size the
    // page happened to load with. We recompute the same rows client-side
    // from the embedded product JSON any time the selection changes.
    var qtyTiersEl = form.querySelector('[data-quantity-tiers]');
    var qtyTiersList = qtyTiersEl ? qtyTiersEl.querySelector('[data-quantity-tiers-list]') : null;
    var qtyOptionIndex = product.options ? product.options.indexOf('Quantity') : -1;
    var sizeOptionIndex = product.options ? product.options.indexOf('Size') : -1;

    function updateQuantityTiers(variant) {
      if (!qtyTiersEl || !qtyTiersList || qtyOptionIndex === -1 || !variant) return;

      var currentSize = sizeOptionIndex > -1 ? variant.options[sizeOptionIndex] : null;

      var rows = product.variants
        .filter(function (v) {
          return sizeOptionIndex === -1 || v.options[sizeOptionIndex] === currentSize;
        })
        .map(function (v) {
          var label = v.options[qtyOptionIndex];
          var qty = parseFloat(String(label).replace(/,/g, ''));
          return { label: label, qty: qty, price: v.price };
        })
        .filter(function (row) { return row.qty > 0; })
        .sort(function (a, b) { return a.qty - b.qty; });

      if (!rows.length) {
        qtyTiersEl.hidden = true;
        return;
      }
      qtyTiersEl.hidden = false;

      var baseEach = rows[0].price / rows[0].qty;
      var bestRow = rows[rows.length - 1];

      qtyTiersList.innerHTML = '';
      rows.forEach(function (row) {
        var each = row.price / row.qty;
        var savingsTotal = (baseEach - each) * row.qty;
        var isBest = row === bestRow;

        var li = document.createElement('li');
        li.className = 'dtf-quantity-tiers__row' + (isBest ? ' dtf-quantity-tiers__row--best' : '');

        var totalSpan = document.createElement('span');
        totalSpan.className = 'dtf-quantity-tiers__total';
        totalSpan.appendChild(document.createTextNode(row.label + ', ' + money(row.price) + ' total'));
        if (isBest) {
          var badge = document.createElement('span');
          badge.className = 'dtf-quantity-tiers__badge';
          badge.textContent = 'Best value';
          totalSpan.appendChild(badge);
        }

        var eachSpan = document.createElement('span');
        eachSpan.className = 'dtf-quantity-tiers__each';
        var eachText = money(each) + '/ea';
        if (baseEach - each > 0) {
          eachText += ' · Save ' + money(savingsTotal);
        }
        eachSpan.textContent = eachText;

        li.appendChild(totalSpan);
        li.appendChild(eachSpan);
        qtyTiersList.appendChild(li);
      });
    }

    function findVariant() {
      var selected = {};
      form.querySelectorAll('input[type=radio]:checked').forEach(function (el) {
        selected[el.name] = el.value;
      });
      return product.variants.find(function (v) {
        return v.options.every(function (optVal, i) {
          var key = 'option' + (i + 1);
          return selected[key] === undefined || selected[key] === optVal;
        });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceNow) priceNow.textContent = money(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = money(variant.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-label-available') || 'Add to Cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
      }
      if (inventoryEl) {
        inventoryEl.textContent = variant.available ? 'In stock, ready to ship' : 'Currently sold out';
        inventoryEl.className = 'product-inventory ' + (variant.available ? 'in-stock' : 'out-stock');
      }
      updateQuantityTiers(variant);
      if (gallery && gallery.showSlideByMediaId && variant.featured_image) {
        gallery.showSlideByMediaId(variant.featured_image.id);
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    form.addEventListener('change', updateUI);
    updateUI();

    // Validate file size the moment a file is chosen, so shoppers get
    // instant feedback instead of finding out only after they hit Add to
    // Cart (or worse, after Shopify's server rejects the request).
    form.querySelectorAll('input[type="file"]').forEach(function (fileInput) {
      fileInput.addEventListener('change', function () {
        var file = fileInput.files && fileInput.files[0];
        if (file && file.size > MAX_UPLOAD_BYTES) {
          showFormMessage(form, 'That file is ' + formatMB(file.size) + ', which is over the 20MB upload limit. Please choose a smaller file.');
          if (addBtn) addBtn.disabled = true;
        } else {
          clearFormMessage(form);
          updateUI();
        }
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var oversized = findOversizedFile(form);
      if (oversized) {
        showFormMessage(form, 'That file is ' + formatMB(oversized.size) + ', which is over the 20MB upload limit. Please choose a smaller file and try again.');
        return;
      }

      clearFormMessage(form);
      var prevLabel = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.ok) return r.json();
          return r.json()
            .catch(function () { return {}; })
            .then(function (data) {
              throw new Error(data.description || data.message || 'We couldn\'t add that to your cart. Please try again, or use a smaller file if you attached one.');
            });
        })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
          if (addBtn) addBtn.textContent = 'Added ✓';
          setTimeout(function () {
            if (addBtn) { addBtn.disabled = false; addBtn.textContent = prevLabel || 'Add to Cart'; }
          }, 1600);
        })
        .catch(function (err) {
          showFormMessage(form, (err && err.message) || 'Something went wrong adding this to your cart. Please try again.');
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = prevLabel || 'Add to Cart'; }
        });
    });
  });

  // ---------- cart line quantity change (AJAX) ----------
  document.querySelectorAll('[data-cart-line-form]').forEach(function (form) {
    var input = form.querySelector('input[name="quantity"]');
    var line = form.getAttribute('data-line');
    if (!input) return;
    var timer;
    input.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: input.value })
        }).then(function () { window.location.reload(); });
      }, 300);
    });
  });

  // ---------- cart line remove ----------
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var line = btn.getAttribute('data-cart-remove');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });
})();
